import { objectsMatch, isItemGeneratedGeoObject, isIGeofence } from '@iotv/iotv-v3-types';
import { getRejectionBucketingFilter } from '@iotv/core-services';
import { getObjectDifferences } from '../../v2/components/generic/ObjectView/DetailCard/util';
const debug = process.env.REACT_APP_DEBUG && false;
const QuarantinableTypeIds = ['Area', 'Place', 'Path', 'Grid', 'Property'];
export const isQuarantinable = (gob) => QuarantinableTypeIds.includes(gob.type);
/** given a nodeEdgeMapper and the output of useGoogleMap, handles Map => Parent component data changes, use in useEffect with dependencies on mapAreas and mapPlaces
 * @param canaryString - A string to check which version of this function is currently running
 * @param referenceItems
 * */
export function quarantinedItemsLogic({ canaryString, referenceItems, gMapState, // State of useGoogleMapState
//mapAreas,
//mapPlaces,
//mapPaths,
//mapGrids,
quarantinedItemsDispatch, contextObject, }) {
    const notQuarantinableBucket = [];
    const bucketingFilter = getRejectionBucketingFilter({ filter: isQuarantinable, rejectionsBucket: notQuarantinableBucket });
    const { areas: mapAreas, places: mapPlaces, paths: mapPaths, grids: mapGrids } = gMapState;
    const mapStateItems = [...mapAreas, ...mapPlaces, ...mapPaths, ...mapGrids].filter(bucketingFilter);
    debug && console.log('quarantinedItemsLogic', 'map state items', mapStateItems);
    const mapStateItemsInEdit = [
        ...Object.values(gMapState.editableAreas ?? {}).map((editArea) => editArea.object),
        ...Object.values(gMapState.editablePaths ?? {}),
        ...Object.values(gMapState.editablePlaces ?? {}),
    ];
    if (notQuarantinableBucket.length > 0) {
        debug && console.log(`quarantinedItemsLogic got not quarantinable items`, notQuarantinableBucket);
    }
    const referenceItemsNodes = referenceItems?.getContainedItems().filter(isQuarantinable) ?? [];
    /* these are made null if empty on return */
    let newItems = [];
    let changedItems = [];
    let removedItems = [];
    let generatedItems = [];
    //let mergedAreas: ValidGeoObjectOrGrid[] | null = []
    let itemsInEdit = referenceItemsNodes.filter((item) => mapStateItemsInEdit.find((msiInEdit) => msiInEdit.sk === item.sk));
    //if (gMapState.mergeLostAreas) {
    //  Object.entries(gMapState.mergeLostAreas).forEach(([mergeAreaSk, mergedAreasUnderSk]) => {
    //    for (const mergedArea of mergedAreasUnderSk) {
    //      mergedAreas!.push(mergedArea)
    //    }
    //  })
    //}
    removedItems = referenceItemsNodes.filter((item) => !mapStateItems.find((shgob) => shgob.sk === item.sk) && !itemsInEdit.find((editItem) => editItem.sk === item.sk));
    const mapAreaRemoved = ['Area', 'Property'].includes(contextObject?.type ?? '') && removedItems.find((ri) => ri.sk === contextObject?.sk);
    const mapPlaceRemoved = ['Place'].includes(contextObject?.type ?? '') && removedItems.find((ri) => ri.sk === contextObject?.sk);
    debug && console.log(`quarantinedItemsLogic ${canaryString} has areas (gridsHash)`, { mapAreas });
    if (referenceItems) {
        for (let mapItem of mapStateItems) {
            // if (isShimmedGeoObject(shgob)) {
            //   const rehydratedGob = geoObjectCodec.fromGeoObject(shgob);
            //   if (rehydratedGob) {
            //     mapItem = rehydratedGob as ValidGeoObject;
            //   }
            // }
            const areasWithGridsMatch = (existing, mapItem) => {
                let match = false;
                if (isIGeofence(existing) && isIGeofence(mapItem)) {
                    const existingGridsHash = existing.metadata?.gridsHash ?? undefined; // If the area already exists, it might not have metadata to check for a grid in
                    const mapItemGridsHash = mapItem.metadata?.gridsHash ?? undefined; // If the area already exists, it might not have metadata to check for a grid in
                    if (existingGridsHash && mapItemGridsHash && existingGridsHash === mapItemGridsHash) {
                        const { metadata: existingMetadata, ...otherExisting } = existing;
                        const { metadata: mapItemMetadata, ...otherMapItem } = mapItem;
                        match = objectsMatch(otherExisting, otherMapItem) && objectsMatch(otherMapItem, otherExisting);
                    }
                    debug && console.log(`quarantinedItemsLogic evaluated existing and mapItem match as`, match);
                }
                return match;
            };
            const existing = referenceItems.getItem(mapItem);
            if (!existing) {
                const isGeneratedItem = isItemGeneratedGeoObject(mapItem);
                if (isGeneratedItem) {
                    generatedItems.push(mapItem);
                    debug && console.log(`quarantinedItemsLogic ${canaryString} has generated item`, { mapItem, existing });
                }
                else {
                    newItems.push(mapItem);
                    debug && console.log(`quarantinedItemsLogic ${canaryString} has new item`, { mapItem, existing });
                }
            }
            const changed = existing ? !(objectsMatch(existing, mapItem) && objectsMatch(mapItem, existing)) && !areasWithGridsMatch(existing, mapItem) : false;
            existing && debug && console.log('diff', getObjectDifferences(existing, mapItem));
            if (changed) {
                debug && console.log(`quarantinedItemsLogic ${canaryString} has changed item`, { mapItem, existing });
                changedItems.push(mapItem);
            }
            // debug
            if (existing && !changed) {
                debug && console.log(`quarantinedItemsLogic ${canaryString} has existing unchanged item`, mapItem);
            }
        }
    }
    //if (purelyRemovedItems.length > 0) {
    //  debug && console.log(`standardMapObjectUseEffectFn detected removed or in edit items related to contextObject`, purelyRemovedItems)
    //  // currently this will remove inEditItems!
    //  removedItems.push(...(purelyRemovedItems ?? []))
    //}
    if (newItems.length === 0)
        newItems = null;
    if (changedItems.length === 0)
        changedItems = null;
    if (removedItems.length === 0)
        removedItems = null;
    if (generatedItems.length === 0)
        generatedItems = null;
    const action = { type: 'setPresent', value: { changedItems, newItems, removedItems, generatedItems } };
    debug && console.log(`useThemedMap: Updating quarantined items state`, action);
    quarantinedItemsDispatch(action);
}
